import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { Field } from 'react-final-form';
import FieldGroup from '../../../FieldGroup.jsx';
import FormModal from '../../../FormModal.jsx';

const AddChangeImpactTypeFormModal = ({
  updateChangeImpactTypes,
  changeImpactTypes,
  retrieveChangeImpactTypes,
  onHide,
  show,
}) => {
  const createResource = (values) => {
    const randomId = () => Math.random().toString(36).slice(2, 7);

    const sendData = {
      change_impact_types: [
        ...changeImpactTypes,
        {
          id: null,
          editor: false,
          priority: changeImpactTypes.length,
          name: values.changeImpactType,
          allowDelete: true,
          allowEditor: true,
          draggableId: randomId(),
          tableShow: true,
        },
      ],
    };
    return updateChangeImpactTypes(sendData);
  };

  const validate = useCallback((values) => {
    const errors = {};
    if (!values.changeImpactType) {
      errors.changeImpactType = 'Title Impact Type is required';
    }
    return errors;
  }, []);

  return (
    <FormModal
      createResource={createResource}
      onHide={onHide}
      onSubmitSuccess={(result) => {
        retrieveChangeImpactTypes();
      }}
      resourceName="Change Impact Type"
      show={show}
      validate={validate}
    >
      <Field
        id="changeImpactType"
        name="changeImpactType"
        label="Change Impact Type"
        placeholder="Enter Title"
        type="text"
        component={FieldGroup}
      />
    </FormModal>
  );
};

AddChangeImpactTypeFormModal.propTypes = {
  onHide: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
};

export default AddChangeImpactTypeFormModal;
